import React from 'react';
import { Box, Switch, Typography } from '@mui/material';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import { FONT_ENUM } from '../../types/global/fonts.types';
import {
    BRAND_LUXE_PRIMARY,
    BRAND_OUTLINE_VARIANT,
    BRAND_SURFACE_CONTAINER_HIGHEST,
    BRAND_SURFACE_CONTAINER_LOW,
} from './brandDashboardTokens';

const switchSx = {
    flexShrink: 0,
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: BRAND_LUXE_PRIMARY,
        '& + .MuiSwitch-track': { backgroundColor: 'rgba(255,201,101,0.5)', opacity: 1 },
    },
    '& .MuiSwitch-track': { opacity: 1, backgroundColor: BRAND_OUTLINE_VARIANT },
};

export function WorldwideCampaignBlock({
    checked,
    onChange,
}: {
    checked: boolean;
    onChange: (checked: boolean) => void;
}) {
    return (
        <Box
            sx={{
                p: { xs: 2.5, sm: 3 },
                borderRadius: 2,
                border: '2px solid',
                borderColor: checked ? BRAND_LUXE_PRIMARY : BRAND_OUTLINE_VARIANT,
                bgcolor: checked ? 'rgba(255, 201, 101, 0.08)' : BRAND_SURFACE_CONTAINER_HIGHEST,
                boxShadow: checked ? '0 0 28px rgba(255, 201, 101, 0.22)' : 'none',
                transition: 'border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, minWidth: 0 }}>
                    <Box
                        sx={{
                            width: 44,
                            height: 44,
                            borderRadius: 2,
                            flexShrink: 0,
                            bgcolor: checked ? 'rgba(255, 201, 101, 0.2)' : BRAND_SURFACE_CONTAINER_LOW,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <PublicOutlinedIcon sx={{ color: BRAND_LUXE_PRIMARY, fontSize: 24 }} />
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography
                            sx={{
                                fontSize: 10,
                                fontFamily: FONT_ENUM.MAIN_BOLD,
                                textTransform: 'uppercase',
                                letterSpacing: '0.14em',
                                color: checked ? BRAND_LUXE_PRIMARY : 'rgba(255,255,255,0.45)',
                                mb: 0.5,
                            }}>
                            Global reach
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: FONT_ENUM.MAIN_BOLD,
                                fontSize: { xs: 17, sm: 20 },
                                color: '#fff',
                                lineHeight: 1.2,
                            }}>
                            Worldwide campaign
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: 13,
                                color: 'rgba(255,255,255,0.55)',
                                mt: 1,
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                lineHeight: 1.45,
                            }}>
                            Pull in applications from creators across the globe. Location above still appears on the
                            public page.
                        </Typography>
                    </Box>
                </Box>
                <Switch checked={checked} onChange={(_, v) => onChange(v)} sx={switchSx} />
            </Box>
        </Box>
    );
}
